import {
    CoachingEventStatus,
    CoachingEventType,
    CommitmentSummaryListItem,
    GoalModel,
} from '../coaching-base/general';
import { ObjectDateTransformer } from '../coaching-insight/coaching-insight.model';
import { ModelTransformer } from '../common/common.model';
import { pluck } from '../store.decorator';

import { TranslationKeyMap } from './coaching-commitment.i18n';
import { ObservationFormValue } from './commitment-observations/observations.commitment.form';
import { GoalEventDataPoint } from './models/goal-event-data-point.model';

export class CommitmentSummaryItemTransformer
    implements
        ModelTransformer<
            CommitmentSummaryListItem[],
            CommitmentSummaryListItem[]
        >
{
    transform(model: CommitmentSummaryListItem[]): CommitmentSummaryListItem[] {
        // TODO revise
        model = model.map((c) => {
            const dateTransformer =
                new ObjectDateTransformer<CommitmentSummaryListItem>({
                    startDate: 'L',
                    endDate: 'L',
                    initialDate: 'L',
                    events: {
                        sessionDate: 'L',
                        createdOn: 'L',
                        updatedOn: 'L',
                        startTime: 'L',
                        endTime: 'L',
                    },
                    createdOn: 'L',
                    goals: {
                        startDate: 'L',
                        endDate: 'L',
                    },
                    latestEvent: {
                        sessionDate: 'L',
                        createdOn: 'L',
                        updatedOn: 'L',
                        startTime: 'L',
                        endTime: 'L',
                    },
                    notes: {
                        sessionDate: null,
                        createdOn: null,
                        publishedOn: null,
                    },
                });
            return dateTransformer.transform(c);
        });
        model.forEach((s: CommitmentSummaryListItem) => {
            if (s.commitmentId === 0) {
                s.commitmentId = null;
            }

            // map latest active goal data
            s.goals = s.goals || [];
            if (s.goals.length) {
                s.goals.forEach((g) => {
                    if (
                        typeof g.estimatedCompletionDate === 'string' &&
                        !isNaN(Date.parse(g.estimatedCompletionDate))
                    ) {
                        g.estimatedCompletionDate = new Date(
                            g.estimatedCompletionDate,
                        );
                    } else {
                        g.estimatedCompletionDate = null;
                    }
                });
                s.goals.sort((a: GoalModel, b: GoalModel) => {
                    if (!a.estimatedCompletionDate) return 1;
                    else if (!b.estimatedCompletionDate) return -1;
                    return (
                        a.estimatedCompletionDate.getTime() -
                        b.estimatedCompletionDate.getTime()
                    );
                });
            }
        });
        return model;
    }
}

/// /

// TODO revise. move. change key arg from string to prop accessor
export function dateSort<T>(key: string, arr: T[]): T[] {
    if (!arr) return;
    return arr.sort((a, b) => {
        const va = pluck<any>(a, key);
        const vb = pluck<any>(b, key);
        const ta =
            !va || !(va instanceof Date) || isNaN(va.getTime())
                ? 0
                : va.getTime();
        const tb =
            !vb || !(va instanceof Date) || isNaN(vb.getTime())
                ? 0
                : vb.getTime();
        return tb - ta;
    });
}

export const injectUnsavedLinkedObservations = (
    events: GoalEventDataPoint[],
    linkedObservations: ObservationFormValue[],
): GoalEventDataPoint[] => {
    let datapoints = [...events];

    if (linkedObservations) {
        linkedObservations.forEach((a) => {
            // skip if event (observation) is already a history datapoint.
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            if (
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                a.event &&
                a.event.eventId &&
                events.find((b) => b.eventId === a.event.eventId)
            )
                return;

            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const obs = {
                eventId: a.event.eventId,
                date: a.event.sessionDate,
                eventTypeId: CoachingEventType.OBSERVATION,
                eventTypeName: TranslationKeyMap._9548_OBSERVATION,
                commitmentStatusId: a.event.published
                    ? CoachingEventStatus.ACTIVE
                    : CoachingEventStatus.DRAFT,
                commitmentStatusName: a.event.published
                    ? TranslationKeyMap._125_ACTIVE
                    : TranslationKeyMap._9476_DRAFT,
            } as GoalEventDataPoint;
            datapoints = insertSorted(obs, datapoints, 'date');
        });
    }
    return datapoints;
};

const insertSorted = (insert: any, arr: any[], byKey: string): any[] => {
    let isLast = true;

    if (arr.length === 0) {
        arr.push(insert);
    } else {
        for (let i = 0, length = arr.length; i < length; i++) {
            if (insert[byKey] < arr[i][byKey]) {
                isLast = false;
                arr.splice(i, 0, insert);
                break;
            }
        }
        if (isLast) {
            arr.push(insert); // add to the end
        }
    }
    return arr;
};
